import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import dayjs from 'dayjs';

const DeviceHistoryChart = ({ statistics }) => {
    const [seriesData, setSeriesData] = useState([]);

    useEffect(() => {
        // Process the statistics data to fit the ApexCharts format
        const formattedData = statistics.map((data) => ({
            x: dayjs(data.created_at).format('YYYY-MM-DD HH:mm:ss'), // Format created_at to a readable string
            y: data.status, // Status remains the same (0 for 'off', 1 for 'on')
            additionalInfo: data.additionalInfo, // Add additional information if needed
        }));

        setSeriesData(formattedData);
    }, [statistics]);

    // ApexCharts options
    const options = {
        chart: {
            type: 'line',
            height: 350,
            zoom: { enabled: false },
            toolbar: {
                show: false
            }
        },
        xaxis: {
            type: 'datetime',
            title: { text: 'Time' },
        },
        yaxis: {
            min: 0,
            max: 1,
            tickAmount: 1,
            labels: {
                formatter: (value) => (value === 1 ? 'On' : 'Off'),
            },
            title: { text: 'Status' },
        },
        stroke: {
            curve: 'stepline',
        },
        tooltip: {
            x: {
                format: 'yyyy-MM-dd HH:mm:ss' // Show date/time in tooltip
            },
            y: {
                formatter: (value) => (value === 1 ? 'Status: On' : 'Status: Off'), // Custom label for status
            },
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
                const dataPoint = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
                return `<div style="padding: 8px;">
                            <strong>${dayjs(dataPoint.x).format('YYYY-MM-DD HH:mm:ss')}</strong><br/>
                            Status: ${dataPoint.y === 1 ? 'On' : 'Off'}
                        </div>`;
            }
        }
    };

    return (
        <div>
            <Chart
                options={options}
                series={[{ name: 'Status', data: seriesData }]}
                type="line"
                height={250}
            />
        </div>
    );
};

export default DeviceHistoryChart;
